import { AloBase } from '@/models/alo/AloBase';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';


export interface IUiState {   
    contentHeight:number
    rightDrawerOpen:boolean
    rightDrawerEnable:boolean
    drawerOpen:boolean
    drawerEnable:boolean
    snackMessages:  Array<string>    
    showCart:boolean

    searchUser:string
    sortUserDesc:boolean
    sortUserBy:string	

    searchMailTemplate:string
    sortMailTemplateDesc:boolean
    sortMailTemplateBy:string	

    searchMailSkin:string
    sortMailSkinDesc:boolean
    sortMailSkinBy:string

    searchPiscine:string
    sortPiscineDesc:boolean
    sortPiscineBy:string	
    monthPiscine:string|null
    
    searchActivity:string
    sortActivityDesc:boolean
    sortActivityBy:string

    searchForfait:string
    sortForfaitDesc:boolean
    sortForfaitBy:string	

    searchMns:string
    sortMnsDesc:boolean
    sortMnsBy:string	

    searchContact:string
    sortContactDesc:boolean
    sortContactBy:string	
    monthContact:string|null

    searchNewsletter:string
    sortNewsletterDesc:boolean
    sortNewsletterBy:string	

    searchCours:string
    sortCoursDesc:boolean
    sortCoursBy:string	

    searchCommande:string
    sortCommandeDesc:boolean
    sortCommandeBy:string	
    monthCommande:string|null

    searchFamily:string
    sortFamilyDesc:boolean
    sortFamilyBy:string	
    

}

//Initial State
const state: IUiState = {      
    contentHeight:250,
    rightDrawerOpen:false,
    rightDrawerEnable:false,
    drawerOpen:false,
    drawerEnable:false,
    snackMessages: [],
    showCart:false,

    searchUser:"",
    sortUserDesc:false,
    sortUserBy:"",

    searchMailTemplate:"",
    sortMailTemplateDesc:false,
    sortMailTemplateBy:"",

    searchMailSkin:"",
    sortMailSkinDesc:false,
    sortMailSkinBy:"",

    searchPiscine:"",
    sortPiscineDesc:false,
    sortPiscineBy:"",
    monthPiscine:null,

    searchActivity:"",
    sortActivityDesc:false,
    sortActivityBy:"",

    searchForfait:"",
    sortForfaitDesc:false,
    sortForfaitBy:"",
    
    searchMns:"",
    sortMnsDesc:false,
    sortMnsBy:"",

    searchContact:"",
    sortContactDesc:false,
    sortContactBy:"",
    monthContact:null,

    searchNewsletter:"",
    sortNewsletterDesc:false,
    sortNewsletterBy:"",

    searchCours:"",
    sortCoursDesc:false,
    sortCoursBy:"",

    searchCommande:"",
    sortCommandeDesc:false,
    sortCommandeBy:"",
    monthCommande:null,

    searchFamily:"",
    sortFamilyDesc:false,
    sortFamilyBy:"",
    
} 

export default state